/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import {
    Box,
    Button,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'
import {useGigyaModal} from '../../context/gigya-modal'
import {noop} from '@salesforce/retail-react-app/app/utils/utils'

const ModalLogin = ({isNotifyMe = false, callback = noop}) => {
    const {openModal} = useGigyaModal()
    const styles = useMultiStyleConfig('Wishlist')

    return (
        <Box>
            <Button
                w={isNotifyMe ? '100%' : {base: '100%', md: 'auto'}}
                variant={'primary'}
                {...styles.wishlistLoginButton}
                onClick={() => openModal(isNotifyMe, callback)}
            >
                <FormattedMessage defaultMessage="Login" id="login_form.message.login" />
            </Button>
        </Box>
    )
}

ModalLogin.propTypes = {
    isNotifyMe: PropTypes.bool,
    callback: PropTypes.func,
    pid: PropTypes.string,
}

export default ModalLogin
